module.exports = __webpack_public_path__ + "media/assets/success-66d03fcbb32aa0dcf2443ff102ceeef2.svg";